import { LANGUAGE_KEY } from "./constants";
import Storage from "./Storage";
// Allow loading translation strings for just one language.
export const messageLoader = {
	'de': _ => import('../../i18n.min/de.json'),
	'vi': _ => import('../../i18n.min/vi.json'),
	'en': _ => import('../../i18n.min/en.json'),
	'es': _ => import('../../i18n.min/es.json'),
	'fr': _ => import('../../i18n.min/fr.json'),
	'ko': _ => import('../../i18n.min/ko.json'),
	'ro': _ => import('../../i18n.min/ro.json'),
	'ru': _ => import('../../i18n.min/ru.json'),
	'zh': _ => import('../../i18n.min/zh.json'),
	'zh-TW': _ => import('../../i18n.min/zh-TW.json'),
	'lo': _ => import('../../i18n.min/lo.json')
};
class LanguageStorage extends Storage {

	constructor() {
		super(LANGUAGE_KEY);
		this._storage;
	}

	get language() {
		//kiểm tra trình duyệt đang là ngôn ngữ gì, mặc định là vi
		const language = (navigator.languages && navigator.languages[0]) ||
			navigator.language ||
			navigator.userLanguage ||
			'vi';
		const normalized = language.replace('_', '-');
		const baseLanguage = normalized.split('-')[0].toLowerCase();
		const htmlLang = messageLoader[normalized] ? language : messageLoader[baseLanguage] ? baseLanguage : 'vi';
		if (this._storage) {
			return messageLoader[this._storage] ? this._storage : htmlLang
		}
		return htmlLang;
	}

	set language(u) {
		this._storage = u;
	}
}

export default LanguageStorage;
export const language = new LanguageStorage();
